import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { GetDeletionBusinessAdapter } from '../adapters/getDeletionBusinessAdapter';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IGetDeletionBusinessResult } from '../pages/interfaces/entities/IGetDeletionBusinessResult';

/**
 * 削除ページのUseCase
 */
export class GetDeletionBusinessUseCase {
  /**
   * 取引情報の取得
   * @param repository - 在庫情報のリポジトリ
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param earlyPeriod - 表示期間の開始日
   * @param latterPeriod - 表示期間の終了日
   * @param sortTarget - ソート対象
   * @param filterItems - フィルターの一覧
   * @param adapter -
   */
  public async Execute(
    repository: IInventoryRepository,
    sortType: SortType,
    limit: number,
    offset: number,
    earlyPeriod: string,
    latterPeriod: string,
    sortTarget: string,
    filterItems: FilterContentItem[],
    adapter: GetDeletionBusinessAdapter
  ): Promise<INetworkResult<IGetDeletionBusinessResult, IError>> {
    // フロント側から指定されたフィルターをリクエスト用の形式に変換
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    try {
      const response = await repository.get(sortType, limit, offset, earlyPeriod, latterPeriod, undefined, sortTarget, filterItem, '');
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: adapter.adaptUiData(response.status.data.result),
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
